var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _line2, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopSectionPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 868,
  height: 1009,
  viewBox: "0 0 868 1009",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 868,
  y1: 1.2832,
  x2: -4.37113e-8,
  y2: 1.28313,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.7832,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.7832,
  width: 868,
  height: 413,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 500.783,
  width: 568,
  height: 18,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 526.783,
  width: 568,
  height: 62,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 596.783,
  width: 568,
  height: 40,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 644.783,
  width: 568,
  height: 40,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  y: 696.783,
  width: 568,
  height: 14,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 500.783,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 574.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 608.783,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 682.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 868,
  y1: 735.283,
  x2: -4.37113e-8,
  y2: 735.283,
  stroke: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  y: 758.783,
  width: 193,
  height: 128,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  y: 898.783,
  width: 193,
  height: 84,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  y: 994.783,
  width: 193,
  height: 14,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 225,
  y: 758.783,
  width: 193,
  height: 128,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 225,
  y: 898.783,
  width: 193,
  height: 84,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 225,
  y: 994.783,
  width: 193,
  height: 14,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 450,
  y: 758.783,
  width: 193,
  height: 128,
  fill: "#E5E5E5"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 450,
  y: 898.783,
  width: 193,
  height: 84,
  fill: "#E5E5E5"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 450,
  y: 994.783,
  width: 193,
  height: 14,
  fill: "#E5E5E5"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 675,
  y: 758.783,
  width: 193,
  height: 128,
  fill: "#E5E5E5"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 675,
  y: 898.783,
  width: 193,
  height: 84,
  fill: "#E5E5E5"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 675,
  y: 994.783,
  width: 193,
  height: 14,
  fill: "#E5E5E5"
})));
export default SvgDesktopSectionPlaceholder;